import { useEffect, useState } from "react";
import { useParams,Link } from "react-router-dom"
import styled from "styled-components";


const Searched = () => {

  const[search, setSearched] = useState([]);

  let params = useParams();

  const getSearch = async(name) =>{
    const data = await fetch(`https://api.spoonacular.com/recipes/complexSearch?apiKey=${process.env.REACT_APP_API_KEY}&query=${name}`);
    const api = await data.json();
    setSearched(api.results)
  }

  useEffect(() =>{
    getSearch(params.search)
  },[params.search])

  return (
    <Grid>
        {search.map((item)=>{
          return(
            <Card key={item.id}>
              <Link to={"/recipe/" +item.id}>
                <p>{item.title}</p>
                <img src={item.image} alt="" />
              </Link>
            </Card>
          )
        })}
    </Grid>
  )
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  grid-gap: 2rem;
`
const Card = styled.div`
  img{
    border-radius: 2rem;
    object-fit: cover;

  }
  a{
    text-decoration: none;
  }
  p{
    font-size: 1rem;
    font-weight: bold;
    font-family: 'Montserrat', sans-serif;
    margin-bottom: 20px;
  }
`

export default Searched